import { EWalletActions } from "./actions";
import { defaultWalletState } from "./context";
export const walletReducer = (prevState, action) => {
    switch (action.type) {
        case EWalletActions.SET_BATCH:
            return {
                ...prevState,
                ...action.payload.state,
            };
        case EWalletActions.SET_INITIALIZED:
            return {
                ...prevState,
                initialized: {
                    ...prevState.initialized,
                    ...action.payload.initialized,
                },
            };
        case EWalletActions.SET_CACHE:
            return {
                ...prevState,
                ...action.payload.cache,
            };
        case EWalletActions.SET_WALLET_DETAILS:
            return {
                ...prevState,
                details: action.payload.details,
            };
        case EWalletActions.SET_ERROR:
            return {
                ...prevState,
                error: action.payload.error,
            };
        case EWalletActions.SET_BALANCE:
            return {
                ...prevState,
                balance: action.payload.balance,
            };
        case EWalletActions.SET_ACTIVE_WALLET:
            return {
                ...prevState,
                activeWallet: action.payload.activeWallet,
            };
        case EWalletActions.SET_DAPP_CONNECTOR:
            return {
                ...prevState,
                dAppConnector: action.payload.dAppConnector,
            };
        case EWalletActions.CLEAR_LOCAL_STORAGE:
            return {
                ...defaultWalletState,
                dAppConnector: prevState.dAppConnector, // Keep the dAppConnector instance.
            };
        case EWalletActions.SET_PERFORMING_SYNC:
            return {
                ...prevState,
                ...action.payload.performingSync,
            };
        default:
            return prevState;
    }
};
//# sourceMappingURL=reducer.js.map